<ng-container>
    <div class="lm-lpl-editor-toolbar toolbar editor-toolbar formatter-toolbar">
        <div class="buttonset">
            <button *ngIf="validationOptions?.type==='secClass' && !readonly"
                soho-menu-button
                class="btn-editor"
            >{{ 'LPL_EDITOR_LPL_HELPER' | translate }}</button>
            <ul class="popupmenu">
                <li>
                    <a href="#" (click)="onRepositoryHelperClickEvent({request: 'snippet' })">{{ 'LPL_EDITOR_SNIPPETS' | translate }}</a>
                </li>
                <li>
                    <a href="#" (click)="onRepositoryHelperClickEvent({request: 'objects' })">{{ 'LPL_EDITOR_OBJECT_LOOKUP' | translate }}</a>
                </li>
                <li class="separator"></li>
                <li>
                    <a href="#" (click)="onRepositoryHelperClickEvent({request: 'actions' })">{{ 'LPL_EDITOR_ACTIONS' | translate }}</a>
                </li>
                <li>
                    <a href="#" (click)="onRepositoryHelperClickEvent({request: 'fields' })">{{ 'LPL_EDITOR_FIELDS' | translate }}</a>
                </li>
                <li>
                    <a href="#" (click)="onRepositoryHelperClickEvent({request: 'ontology' })">{{ 'LPL_EDITOR_Ontology' | translate }}</a>
                </li>
                <li class="separator"></li>
                <li>
                    <a href="#" (click)="onRepositoryHelperClickEvent({request: 'conditionBuilder' })">{{ 'LPL_EDITOR_CONDITION_BUILDER' | translate }}</a>
                </li>
             </ul>
            <button
                    soho-menu-button
                    class="btn-editor"
            >{{ 'LPL_EDITOR_COMMANDS' | translate }}</button>
            <ul class="popupmenu">
                <li><a href="#" (click)="onMonacoClickEvent('editor.action.quickCommand')">{{ 'LPL_EDITOR_COMMAND_PALETTE' | translate }}</a></li>
                <li class="separator"></li>
                <li><a href="#" (click)="onMonacoClickEvent('editor.foldAll')">{{ 'LPL_EDITOR_FOLD_ALL' | translate }}</a></li>
                <li><a href="#" (click)="onMonacoClickEvent('editor.fold')">{{ 'LPL_EDITOR_FOLD' | translate }}</a></li>
                <li><a href="#" (click)="onMonacoClickEvent('editor.unfoldAll')">{{ 'LPL_EDITOR_UNFOLD_ALL' | translate }}</a></li>
                <li><a href="#" (click)="onMonacoClickEvent('editor.unfold')">{{ 'LPL_EDITOR_UNFOLD' | translate }}</a></li>
            </ul>
            <button
                soho-button="icon"
                icon="search"
                class="btn-editor"
                (click)="onMonacoClickEvent('actions.find')"
            ></button>
        </div>
        <span *ngIf="!readonly && !canValidateLpl"
            class="tag"
            soho-tooltip
                [popover]="true"
                [content]="validatorTooltip"
                [placement]="'offset'"
        >{{ 'LPL_EDITOR_VALIDATOR_OFF' | translate }}</span>
    </div>
    <div class="editor-container lm-lpl-editor" #editorContainer soho-alert></div>
</ng-container>
